import { render } from "./masterpips.vue?vue&type=template&id=ff873c74"
import script from "./masterpips.vue?vue&type=script&lang=js"
export * from "./masterpips.vue?vue&type=script&lang=js"

import "./masterpips.vue?vue&type=style&index=0&id=ff873c74&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__